import { reducerWithInitialState } from "typescript-fsa-reducers"
import { qrActions } from "../actions/QRAction"

export interface QRState {
  // 用途車種
  vehicleType: string
  // 型式
  carModel: string
  // 初度登録年
  firstInspectionYear: string
  // 初度登録月
  firstInspectionMonth: string
  // 車名
  carName: string
  // 自動ブレーキ
  automaticBraking: string
  // 自動ブレーキ(あり/なし/わからない)が押されたかどうかの情報
  aebButtonSelected: string
  // スキャンで取得したかのフラグ
  isScan: boolean
  // AEB選択項目を画面で表示したかのフラグ
  isAEBShown: boolean
}

const initialState: QRState = {
  vehicleType: "",
  carModel: "",
  firstInspectionYear: "",
  firstInspectionMonth: "",
  carName: "",
  automaticBraking: "",
  aebButtonSelected: "",
  isScan: false,
  isAEBShown: false
}
// Reduxを利用した画面間共通の車検証情報state初期化処理
export const qrReducer = reducerWithInitialState(initialState)
  .case(qrActions.updateVehicleType, (state, vehicleType) => {
    return { ...state, vehicleType }
  })
  .case(qrActions.updateCarModel, (state, carModel) => {
    return { ...state, carModel }
  })
  .case(qrActions.updateFirstInspectionYear, (state, firstInspectionYear) => {
    return { ...state, firstInspectionYear }
  })
  .case(qrActions.updateFirstInspectionMonth, (state, firstInspectionMonth) => {
    return { ...state, firstInspectionMonth }
  })
  .case(qrActions.updateCarName, (state, carName) => {
    return { ...state, carName }
  })
  .case(qrActions.updateAutomaticBraking, (state, automaticBraking) => {
    return { ...state, automaticBraking }
  })
  .case(qrActions.updateAebButtonSelected, (state, aebButtonSelected) => {
    return { ...state, aebButtonSelected }
  })
  .case(qrActions.updateIsScan, (state, isScan) => {
    return { ...state, isScan }
  })
  .case(qrActions.updateIsAEBShown, (state, isAEBShown) => {
    return { ...state, isAEBShown }
  })
  .case(qrActions.reset, (state) => {
    return { ...state, ...initialState }
  })
  .default((state) => {
    return state
  })
